import React from "react"
import RolesForm from "./form"

const defaultValues = {
  name: "",
  description: "",
  permissions: [],
}

const CreateRoles = ({ HeaderComponent }) => {
  return (
    <React.Fragment>
      <RolesForm
        defaultValues={defaultValues}
        HeaderComponent={HeaderComponent}
      />
    </React.Fragment>
  )
}

export default CreateRoles
